import { formatTL } from "../lib/format";
import { AYLAR } from "./AyYilSecici";

export const TahsilatAylikTablo = ({ aylik = [], yil, seciliAy, onAySec }) => {
  const toplam = aylik.reduce(
    (t, a) => ({
      fatura_adet: t.fatura_adet + a.fatura_adet,
      kesilen: t.kesilen + a.kesilen,
      tahsil_edilen: t.tahsil_edilen + a.tahsil_edilen,
      bekleyen: t.bekleyen + a.bekleyen,
      yapilan_tahsilat: t.yapilan_tahsilat + a.yapilan_tahsilat,
    }),
    { fatura_adet: 0, kesilen: 0, tahsil_edilen: 0, bekleyen: 0, yapilan_tahsilat: 0 }
  );
  const oran = toplam.kesilen > 0 ? (toplam.tahsil_edilen / toplam.kesilen) * 100 : 0;
  const oranRenk = (o, kesilen) => (kesilen <= 0 ? "text-muted-foreground" : o >= 80 ? "text-emerald-700" : o >= 50 ? "text-amber-700" : "text-red-700");

  return (
    <div className="rounded-xl border bg-card overflow-hidden" data-testid="tahsilat-aylik-tablo">
      <div className="border-b bg-muted/40 px-4 py-3">
        <p className="text-sm font-semibold">Aylık Tahsilat Özeti — {yil}</p>
        <p className="text-xs text-muted-foreground">Kesilen fatura ve tahsilat durumu ay bazında — bir aya tıklayarak özeti o aya göre filtreleyin</p>
      </div>
      <div className="w-full overflow-x-auto">
        <table className="w-full text-sm">
          <thead className="bg-muted/50">
            <tr className="text-left text-xs uppercase tracking-wide text-muted-foreground">
              <th className="px-4 py-2.5">Ay</th>
              <th className="px-4 py-2.5 text-right">Fatura</th>
              <th className="px-4 py-2.5 text-right">Kesilen Tutar</th>
              <th className="px-4 py-2.5 text-right">Tahsil Edilen</th>
              <th className="px-4 py-2.5 text-right">Bekleyen</th>
              <th className="px-4 py-2.5 text-right">Tahsilat %</th>
              <th className="px-4 py-2.5 text-right">O Ay Yapılan Tahsilat</th>
            </tr>
          </thead>
          <tbody>
            {aylik.map((a) => {
              const bos = a.fatura_adet === 0 && a.yapilan_tahsilat === 0;
              const secili = seciliAy === a.ay;
              return (
                <tr
                  key={a.ay}
                  onClick={() => onAySec?.(a.ay)}
                  className={`border-t border-border/60 cursor-pointer transition-colors ${secili ? "bg-[hsl(var(--primary))]/[0.06] font-semibold" : "hover:bg-muted/40"} ${bos ? "text-muted-foreground" : ""}`}
                  data-testid={`tahsilat-aylik-row-${a.ay}`}
                >
                  <td className="px-4 py-2 whitespace-nowrap">{AYLAR[a.ay - 1]}</td>
                  <td className="px-4 py-2 text-right tabular-nums">{a.fatura_adet.toLocaleString("tr-TR")}</td>
                  <td className="px-4 py-2 text-right tabular-nums whitespace-nowrap">{bos ? "—" : formatTL(a.kesilen)}</td>
                  <td className="px-4 py-2 text-right tabular-nums whitespace-nowrap text-emerald-700">{bos ? "—" : formatTL(a.tahsil_edilen)}</td>
                  <td className={`px-4 py-2 text-right tabular-nums whitespace-nowrap ${a.bekleyen > 0 ? "text-amber-700" : ""}`}>{bos ? "—" : formatTL(a.bekleyen)}</td>
                  <td className={`px-4 py-2 text-right tabular-nums ${oranRenk(a.oran, a.kesilen)}`}>{a.kesilen > 0 ? `%${a.oran.toLocaleString("tr-TR")}` : "—"}</td>
                  <td className="px-4 py-2 text-right tabular-nums whitespace-nowrap">
                    {a.yapilan_tahsilat > 0 ? (
                      <>
                        {formatTL(a.yapilan_tahsilat)} <span className="text-[11px] text-muted-foreground">({a.yapilan_tahsilat_adet})</span>
                      </>
                    ) : "—"}
                  </td>
                </tr>
              );
            })}
          </tbody>
          <tfoot>
            <tr className="border-t-2 bg-muted/30 font-semibold" data-testid="tahsilat-aylik-toplam">
              <td className="px-4 py-2.5">TOPLAM</td>
              <td className="px-4 py-2.5 text-right tabular-nums">{toplam.fatura_adet.toLocaleString("tr-TR")}</td>
              <td className="px-4 py-2.5 text-right tabular-nums whitespace-nowrap">{formatTL(toplam.kesilen)}</td>
              <td className="px-4 py-2.5 text-right tabular-nums whitespace-nowrap text-emerald-700">{formatTL(toplam.tahsil_edilen)}</td>
              <td className="px-4 py-2.5 text-right tabular-nums whitespace-nowrap text-amber-700">{formatTL(toplam.bekleyen)}</td>
              <td className={`px-4 py-2.5 text-right tabular-nums ${oranRenk(oran, toplam.kesilen)}`}>{toplam.kesilen > 0 ? `%${oran.toLocaleString("tr-TR", { maximumFractionDigits: 1 })}` : "—"}</td>
              <td className="px-4 py-2.5 text-right tabular-nums whitespace-nowrap">{formatTL(toplam.yapilan_tahsilat)}</td>
            </tr>
          </tfoot>
        </table>
      </div>
    </div>
  );
};
